/**
 * smarte header search — instant in-field icon toggle
 */
(function () {
  function syncFieldActions(form) {
    const input = form.querySelector('.search__input');
    const clearButton = form.querySelector('.smarte-search-field__clear');
    const submitButton = form.querySelector('.smarte-search-field__submit');

    if (!input || !clearButton || !submitButton) return;

    const hasValue = input.value.trim().length > 0;
    clearButton.classList.toggle('hidden', !hasValue);
    submitButton.classList.toggle('hidden', hasValue);
  }

  function initForm(form) {
    if (form.dataset.smarteSearchInit) return;
    form.dataset.smarteSearchInit = 'true';

    const input = form.querySelector('.search__input');
    if (!input) return;

    input.addEventListener('input', () => syncFieldActions(form));
    form.addEventListener('reset', () => {
      window.requestAnimationFrame(() => syncFieldActions(form));
    });

    syncFieldActions(form);
  }

  function init(root) {
    root.querySelectorAll('.smarte-header__search .search').forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
